export class CommunicationDetails {
    city: string;
    country: string;
    domain: string;
    email: string;
    extraInfo: string;
    houseNumber: string;
    id: string;
    primaryAddress: boolean;
    province: string;
    state: string;
    streetName: string;
    firstName: string;
    lastName: string;
    companyName: string;
    zipCode: string;
    phoneNumbers: any[]
}


// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/communication/add/communication-details.model.ts